import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import Lottie from "lottie-web";
import { isBrowser } from "browser-or-node";

import animationDataMob from "~/src/components/blocks/banner/CharacterRegistration.json";

const CharacterRegistrationMobile = () => {
    let CharacterAnimObjMob = null;
    const container_mob = useRef(null);

    const loadAnimation = () => {
        CharacterAnimObjMob = Lottie.loadAnimation({
            container: container_mob.current,
            loop: true,
            autoplay: true,
            animationData: animationDataMob,
            prerender: true,
        });
    };

    useEffect(() => {
        loadAnimation();
        if (isBrowser) {
            CharacterAnimObjMob.play();
        }
    }, []);

    const scrollTo = () => {
        if (isBrowser) {
            const section = document.querySelector(`#BlockRegistration`);
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    return (
        <SCharacterRegistrationMobile>
            <div
                onClick={scrollTo}
                ref={container_mob}
                style={{ pointerEvents: "all" }}
            />
        </SCharacterRegistrationMobile>
    );
};

const SCharacterRegistrationMobile = styled.div`
    position: absolute;
    width: 51vw;
    bottom: 17.7vw;
    left: 30vw;
    z-index: 3;
    svg {
        width: 100%;
    }
`;

export default CharacterRegistrationMobile;
